"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserLanguageEnum = exports.CsvNumberDecimalSeparatorTypeEnum = exports.CsvDelimiterTypeEnum = exports.NotificationBundleEnum = void 0;
var NotificationBundleEnum;
(function (NotificationBundleEnum) {
    NotificationBundleEnum["OFF"] = "OFF";
    NotificationBundleEnum["DAILY"] = "DAILY";
    NotificationBundleEnum["WEEKLY"] = "WEEKLY";
    NotificationBundleEnum["YEARLY"] = "YEARLY";
})(NotificationBundleEnum || (exports.NotificationBundleEnum = NotificationBundleEnum = {}));
var CsvDelimiterTypeEnum;
(function (CsvDelimiterTypeEnum) {
    CsvDelimiterTypeEnum["COMMA"] = "COMMA";
    CsvDelimiterTypeEnum["SEMICOLON"] = "SEMICOLON";
})(CsvDelimiterTypeEnum || (exports.CsvDelimiterTypeEnum = CsvDelimiterTypeEnum = {}));
var CsvNumberDecimalSeparatorTypeEnum;
(function (CsvNumberDecimalSeparatorTypeEnum) {
    CsvNumberDecimalSeparatorTypeEnum["COMMA"] = ",";
    CsvNumberDecimalSeparatorTypeEnum["DOT"] = ".";
})(CsvNumberDecimalSeparatorTypeEnum || (exports.CsvNumberDecimalSeparatorTypeEnum = CsvNumberDecimalSeparatorTypeEnum = {}));
var UserLanguageEnum;
(function (UserLanguageEnum) {
    UserLanguageEnum["DE"] = "de";
    UserLanguageEnum["EN"] = "en";
})(UserLanguageEnum || (exports.UserLanguageEnum = UserLanguageEnum = {}));
